import type { SlotId } from "../../schemas/index.ts";
import { isNodeId } from "../../shared/index.ts";
import type { NodeDesignsState } from "../types.ts";

export const getSlotPlaceholderId = (
  designsById: NodeDesignsState["designsById"],
  slotsByParentId: NodeDesignsState["slotsByParentId"],
  { parentId, name, index }: SlotId,
): number | undefined => {
  const slotsByName = slotsByParentId[parentId];
  if (!slotsByName) {
    if (!designsById[parentId]) {
      throw new Error(`No node with id: ${parentId} found.`);
    }
    return undefined;
  }
  const slotOrSlots = slotsByName[name];
  if (!slotOrSlots) {
    return undefined;
  }
  const placeholderIdOrIds = Array.isArray(slotOrSlots)
    ? slotOrSlots.map(({ placeholderId }) => placeholderId).filter(isNodeId)
    : slotOrSlots.placeholderId;

  if (!placeholderIdOrIds) {
    return undefined;
  }

  if (Array.isArray(placeholderIdOrIds)) {
    if (index === undefined) {
      throw new Error("Specify index on multi-value slots");
    }
    return placeholderIdOrIds[index];
  }
  return placeholderIdOrIds;
};

export const getPlaceholderIdCreate = (state: NodeDesignsState) => (slotId: SlotId) => {
  const { designsById, slotsByParentId } = state;
  return getSlotPlaceholderId(designsById, slotsByParentId, slotId);
};

export type GetPlaceholderId = ReturnType<typeof getPlaceholderIdCreate>;
